import { render, staticRenderFns } from "./edit-category.vue?vue&type=template&id=3ef99b4c"
import script from "./edit-category.vue?vue&type=script&lang=ts"
export * from "./edit-category.vue?vue&type=script&lang=ts"
import style0 from "./edit-category.vue?vue&type=style&index=0&id=3ef99b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports